export default "__VITE_ASSET__87fe7367__"